export const senderAddress = '0x279E8e0Afb054D8150fD6679C0cB27aBd54f6aF1';
export const adminWalletAddress = '0x279E8e0Afb054D8150fD6679C0cB27aBd54f6aF1';
